<template>
  <section class="wwh-section">
    <v-container>
      <h2 class="wwh-title">
        Who We’ve Helped
        <span class="underline"></span>
      </h2>

      <v-row class="wwh-grid" dense>
        <v-col
          v-for="card in cards"
          :key="card.id"
          :cols="12"
          :md="12"
          :lg="12"
        >
          <WhoWeHelpedCard
            :image="card.image"
            :logo="card.logo"
            :tags="card.tags"
            :title="card.title"
            :description="card.description"
            :route="card.route"
            :reverse="card.reverse"
          />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import WhoWeHelpedCard from './WhoWeHelpedCard.vue'

export default {
  name: 'WhoWeHelped',
  components: { WhoWeHelpedCard },
  data: () => ({
    // Images, logos, and routes match your existing assets & links
    cards: [
      {
        id: 'divacs',
        image: require('@/assets/img/divacs-cover.svg'),
        logo: require('@/assets/img/divac-logo.svg'),
        tags: 'B2B SAAS',
        title: 'DIVACS — Scaling Product Delivery and Investor Confidence',
        description:
          `Scaling Product Delivery and Investor Confidence.
           DIVACS, a B2B SaaS platform, partnered with DIGU to accelerate engineering and design execution.
           In just 35–40 days, DIGU stood up a high-performing pod that reduced development costs by 60% and
           gave the founder time back to focus on fundraising and customer growth.`,
        route: '/divacs',
        reverse: false, // image LEFT (default)
      },
      {
        id: 'sharpscribe',
        image: require('@/assets/img/sharpscribe.svg'),
        logo: require('@/assets/img/sharpscribe-logo.svg'),
        tags: 'B2B SAAS',
        title: 'SharpScribe — Delivering an AI-Powered Healthcare MVP',
        description:
          `SharpScribe worked with DIGU to design and build an MVP that enables doctors to record visits,
           generate AI-powered clinical notes, and sync directly into EPIC EMR. In under 3 months,
           SharpScribe launched into pilot programs with physicians, gathering feedback and setting the stage for adoption and scale.`,
        route: '/sharp-scribe',
        reverse: true, // image RIGHT
      },
      {
        id: 'identity',
        image: require('@/assets/img/anthropic-cover.svg'),
        logo: require('@/assets/img/anthropic-logo.svg'),
        tags: 'B2B SAAS',
        title: 'Anthropic — Growing a Global IAM Services Team',
        description:
          `Identity services firm Anthropic turned to DIGU to build delivery capacity with trained Okta/Auth0 engineers.
           DIGU cut hiring cycles from 12–16 weeks to just 2 weeks, reduced staffing costs by 50%, and positioned
           Anthropic to serve enterprise clients globally.`,
        route: '/anthropic-identity',
        reverse: false, // image LEFT
      },
    ],
  }),
}
</script>

<style scoped>
.wwh-section {
  padding: 4rem 0;
  background: #f7fafc00; /* transparent so it blends like your comp */
}

.wwh-title {
  /* text-align: center; */
  font-size: clamp(24px, 5vw, 44px);
  line-height: 1.2;
  font-weight: 800;
  color: #111827;
  margin: 0 0 44px 0;
  position: relative;
  /* display: inline-block; */
  /* left: 50%; */
  /* transform: translateX(-50%); */
}
.wwh-title .underline {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 12px;
  width: 200px;
  bottom: -10px;
  background-image: url('@/assets/img/underline.svg');
  background-repeat: no-repeat;
  background-size: contain;
}

.wwh-grid {
  max-width: 1300px;
  margin-inline: auto;
  gap: 1.5rem;
}

@media (max-width: 960px) {
  .wwh-section { padding-top: 36px; }
  .wwh-title { font-size: 28px; }
}
</style>
